import { Flex } from "../Flex"
import { InfoIcon } from "../Icons"
import * as styles from "./styles"
import { Tooltip, TooltipProps } from "./Tooltip"

type Props = Pick<TooltipProps, "content" | "inModal" | "leaveDelay"> &
  Readonly<{ contentTestId?: string; tooltipAlign?: TooltipProps["align"] }>

export const InfoIconWithTooltip = ({ content, contentTestId, inModal, leaveDelay, tooltipAlign }: Props) => (
  <Tooltip align={tooltipAlign} content={content} inModal={inModal} leaveDelay={leaveDelay}>
    <Flex data-testid={contentTestId} css={styles.icon}>
      {InfoIcon}
    </Flex>
  </Tooltip>
)

InfoIconWithTooltip.defaultProps = {
  contentTestId: undefined,
  inModal: undefined,
  leaveDelay: 100,
  tooltipAlign: undefined,
}
